module.exports = __webpack_public_path__ + "static/img/sand_15_max.5f139bf7.png";